import type { UserFacility } from "@services/facilityManagement";
import type { MyFacilityListRow } from "types/myFacilityListRow";

/** Map my-facilities rows to sidebar {@link UserFacility} shape. */
export function myFacilityRowToUserFacility(row: MyFacilityListRow): UserFacility {
  const id = row.id ?? row.facility_id;
  return {
    id,
    facility_id: row.facility_id,
    facility_name: row.facility_name,
    city: row.city,
    state: row.state,
    full_address: row.full_address,
    postal_code: row.postal_code ?? undefined,
    country_code: row.country_code ?? undefined,
    ccn_number: row.ccn_number ?? undefined,
    npi_number: row.npi_number ?? undefined,
    medicare_ccn: row.medicare_ccn ?? undefined,
    facility_type_slug: row.facility_type_slug,
    vertical: row.vertical,
    org_name: row.org_name,
    is_profile_approved: row.is_profile_approved,
    medicare_certification_date: row.medicare_certification_date,
    show_tax_compliance_calendar: row.show_tax_compliance_calendar,
    plan_status: row.plan_status,
    is_plan_active: row.is_plan_active,
    transaction_status: row.transaction_status,
    is_restricted: row.is_restricted,
    plan_id: row.plan_id,
    facility_group_id: row.facility_group_id,
    parent_facility_group_id: row.parent_facility_group_id,
    is_parent_facility: row.is_parent_facility,
    is_child_facility: row.is_child_facility,
    child_facilities: row.child_facilities?.map(myFacilityRowToUserFacility),
    is_affable_connected: row.is_affable_connected,
    is_network: row.is_network,
    network_id: row.network_id,
    primary_taxonomy_code: row.primary_taxonomy_code ?? undefined,
    primary_taxonomy_desc: row.primary_taxonomy_desc ?? undefined,
    profile_targeting_json: row.profile_targeting_json ?? undefined,
  };
}

/** Merge profile-save fields into one my-facilities row (shared with layout context). */
export function applyMyFacilityRowPatch(
  rows: MyFacilityListRow[],
  facilityId: number,
  patch: Partial<MyFacilityListRow>,
): MyFacilityListRow[] {
  const matchId = (row: MyFacilityListRow) =>
    (row.facility_id ?? row.id) === facilityId;
  return rows.map((row) =>
    matchId(row)
      ? { ...row, ...patch, facility_id: row.facility_id ?? facilityId }
      : row,
  );
}
